// extracted by mini-css-extract-plugin
export default {"Contacts":"Contact_Contacts__alfvL"};